import React from 'react';
import PropTypes from 'prop-types';
import { ResponsivePie } from '@nivo/pie';
import './GraphArc.scss';
import { GRAPH_STATUSES } from '../../../constants/constants';

const GraphArc = ({ title, data, totalUrlParams, onClick, onTitleClick }) => {
    const buildTotal = () => {
        return (
            data.reduce((sum, item) => sum + item.value, 0)
        );
    };

    const buildData = () => {
        if (buildTotal() === 0) {
            return [];
        } else {
            const results = [];
            if (data && data.length) {
                for (let prop in GRAPH_STATUSES) {
                    if (Object.prototype.hasOwnProperty.call(GRAPH_STATUSES, prop)) {
                        const point = data.find((m) => m.id === GRAPH_STATUSES[prop].label);
                        if (point && point.value) {
                            results.push({
                                id: GRAPH_STATUSES[prop].id,
                                label: GRAPH_STATUSES[prop].label,
                                value: point.value,
                                "color": GRAPH_STATUSES[prop].color,
                                urlParams: point.urlParams,
                            });
                        }
                    }
                }
            }

            return results;
        }
    };

    const onGraphPartClick = (dataPoint) => {
        if (dataPoint?.data?.urlParams) {
            onClick(dataPoint.data.urlParams);
        } else if (dataPoint?.urlParams) {
            onClick(dataPoint.urlParams);
        }
    };

    const titleClassName =
        onTitleClick && typeof onTitleClick === 'function'
            ? 'grapharc-total-label link'
            : 'grapharc-total-label';

    const titleClick = () => {
        if (onTitleClick) {
            onTitleClick();
        }
    };

    const renderToolTip = (datum) => {
        const value = datum?.value;
        const total = buildTotal();

        if (value === undefined || total === 0) {
            return <div>No data</div>;
        }

        const percent = (value / total) * 100;
        return <div>{percent.toFixed(1)}%</div>;
    };

    return (
        <div className="grapharc-section">
            <div className="grapharc-content" style={{ height: '110px', width: '200px' }}>
                <ResponsivePie
                    data={buildData()}
                    startAngle={-90}
                    endAngle={90}
                    innerRadius={0.85}
                    padAngle={3}
                    colors={(datum) => datum.data?.color || '#000'} // Ensures custom colors
                    enableArcLabels={false} // `enableSlicesLabels` is now `enableArcLabels`
                    enableArcLinkLabels={true} // `enableRadialLabels` is now `enableArcLinkLabels`
                    arcLinkLabel="value" // Updated to replace `radialLabel`
                    arcLinkLabelsSkipAngle={0} // Replaces `radialLabelsSkipAngle`
                    arcLinkLabelsTextOffset={0} // Replaces `radialLabelsTextXOffset`
                    arcLinkLabelsOffset={6} // Replaces `radialLabelsLinkOffset`
                    arcLinkLabelsDiagonalLength={0} // Replaces `radialLabelsLinkDiagonalLength`
                    arcLinkLabelsStraightLength={0} // Replaces `radialLabelsLinkHorizontalLength`
                    animate={true}
                    isInteractive={true}
                    onClick={(datum) => onGraphPartClick(datum)} // Adjusted to use `datum`
                    tooltip={({ datum }) => renderToolTip(datum)} // Tooltip now receives `datum`
                />
                <span className="grapharc-total-container">
                    <span
                        className="grapharc-total"
                        onClick={() => onGraphPartClick({ urlParams: totalUrlParams })}
                    >
                        {buildTotal()}
                    </span>
                </span>
                <div className={titleClassName} onClick={titleClick}>
                    {title}
                </div>
            </div>
        </div>
    );
};

GraphArc.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    totalUrlParams: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    onTitleClick: PropTypes.func,
};

export default GraphArc;
